/*
export const apiUrl = 'https://api.borneforyou.co:3022';
export const stripePk = 'pk_test_51MmcJ4EKThLwMcrQ4Ba9DC9X8uWb0m9yOIXH3rT3Wczlyyhs3HuknHkpNHXZPeNkJAmNbEtIMDObtkFPW4DeHjf000xQ7iI8FB';
/*/
//*
export const apiUrl = 'https://api.borneforyou.co';
export const stripePk = 'pk_live_51MmcJ4EKThLwMcrQl11vIei1aI4w2c7aE14PRci29t7hlMSAmBOB3R8eCGWzvMwa6f4H2nYM3iAMJqYF71LCrI2u00ym9SuPcl';
//*/